
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seminar/register/[id]",
      function () {
        return require("private-next-pages/seminar/register/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seminar/register/[id]"])
      });
    }
  